<template>
  <index-content :breadcrumb-items="breadcrumbItems">
    <template #options>
      <div class="n-button-box">
        <nb-add @on-click="openModal" />
      </div>
    </template>
    <search-condition>
      <ns-company v-model="condition.companyId" @on-change="load" />
    </search-condition>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-hover text-center n-table">
        <thead>
          <tr>
            <th class="col-weight-1">{{ $t('label.id') }}</th>
            <th class="col-weight-1">{{ $t('label.company') }}</th>
            <th class="col-weight-1">{{ $t('label.language') }}</th>
            <th class="col-weight-1">{{ $t('label.html') }}</th>
            <th class="col-weight-2">{{ $t('label.i18nKey') }}</th>
            <th class="col-weight-2">{{ $t('label.i18nValue') }}</th>
            <th v-table-action class="action-edit">{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ row.id }}</td>
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td v-enums:Language="row.language"></td>
            <td><n-icon-boolean :value="row.html" /></td>
            <td class="n-ellipsis" :title="row.i18nKey">{{ row.i18nKey | hyphen }}</td>
            <td class="n-ellipsis" :title="row.i18nValue">{{ row.i18nValue | hyphen }}</td>
            <td class="n-button-box">
              <nb-custom v-rw type="error" custom-icon="fas fa-clone" text="copy" @on-click="openCopy(row)" />
              <nb-modal @on-click="openModal(row)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </index-content>
</template>

<script>
import BaseCompanyView from './view';
import ModalCompanyTranslation from './ModalCompanyTranslation';
import { fetch } from '@/api/company/company-translation';
import {beanCopy} from "@/helpers/utils";

export default BaseCompanyView.extend({
  name: 'CompanyTranslation',

  data() {
    return {
      preload: true,
      condition: {
        companyId: 0,
      },
    };
  },

  methods: {
    doLoad() {
      let companyId = this.condition.companyId;
      return fetch({ companyId });
    },

    parse(data) {
      this.records = data;
    },

    openModal(model = {}) {
      this.createModal(ModalCompanyTranslation, { model, on: this });
    },

    openCopy(o) {
      let clone = beanCopy(o);
      clone.id = undefined;
      clone.version = undefined;
      this.createModal(ModalCompanyTranslation, { model: clone, on: this });
    },
  },
});
</script>

<style lang="scss" scoped>
.n-table {
  th.rw-action {
    width: 8.5rem;
  }
}
</style>
